module.exports = __webpack_public_path__ + "static/img/none_data.4cb72ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/none_data.jpg
// module id = f0Lm
// module chunks = 1